export default __webpack_public_path__ + "static/media/4.eb8839c2.jpg";